module.exports = {
      id: "icon-google-play-usage",
      viewBox: "0 0 12.598 13.975",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#icon-google-play",
      toString: function () {
        return this.url;
      }
    }